import { BASE, getCsrfToken } from "./constants";

const getTelegramShortened = async (): Promise<{ redirect_url: string }> => {
  const res = await fetch(`${BASE}/integration/telegram/shortened/`, {
    method: "POST",
    headers: { "X-CSRFToken": getCsrfToken() },
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

const unlinkGoogle = async (): Promise<void> => {
  const res = await fetch("/api/v1/social/", {
    method: "DELETE",
    headers: { "X-CSRFToken": getCsrfToken() },
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
};

const unlinkYandex = async (): Promise<void> => {
  const res = await fetch("/yandex/disconnect/", {
    method: "POST",
    headers: { "X-CSRFToken": getCsrfToken() },
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
};

export { getTelegramShortened, unlinkGoogle, unlinkYandex };
